export type HoneymoonCruise = {
  category: string;
  displayLocation: string;
  displayName: string;
  partner: string;
  webUrl: string;
  displayUrl: string;
  imageAttribution: string;
};

export type HoneymoonHotel = {
  category: string;
  location: string;
  displayLocation: string;
  displayName: string;
  partner: string;
  webUrl: string;
  pricePerNight: string;
  displayPrice: string;
  allInclusive: boolean;
  displayUrl: string;
  imageAttribution: string;
  notes?: string;
};

export enum HoneymoonExperienceName {
  DAY_TRIPS = 'Full day trips',
  EXTREME_SPORTS = 'Extreme sports',
  CRUISES_SAILING = 'Cruises and sailing',
  FOOD_DRINK = 'Food and drink',
  NATURE_WILDLIFE = 'Nature and wildlife',
  ON_ZOLA = 'On Zola',
}

export type HoneymoonExperience = {
  category: string;
  partner: string;
  displayName: HoneymoonExperienceName;
  webUrl: string;
};

export enum HoneymoonDestinationSlug {
  HAWAII = 'hawaii',
  CARIBBEAN = 'caribbean',
  ITALY = 'italy',
  GREECE = 'greece',
  SPAIN = 'spain',
  FRANCE = 'france',
  MEXICO_CENTRAL_AMERICA = 'mexico-central-america',
  FLORIDA_KEYS = 'florida-keys',
  NAPA = 'napa',
  CALIFORNIA_COAST = 'california-coast',
  NATIONAL_PARKS = 'national-parks',
  CHARLESTON = 'charleston',
  BALI = 'bali',
  MALDIVES = 'maldives',
  EUROPE = 'europe',
  CONTINENTAL_US = 'continental-us',
  OTHER = 'other',
}
export type HoneymoonDestination = {
  slug: string;
  key: string;
  description: string;
  moreHotelsLink: string;
  headerImage: string;
  categoryNodeImage: string;
  displayTitle: string;
  nodeTitle?: string; // if different from display title
  linkName: string; // how the destination is used in a sentence, ie in the Caribbean
  experienceCategoryKey?: string;
};

export type HoneymoonSubDestination = {
  name: string;
  key: string;
  slug: string;
  displayTitle: string;
  categoryNodeImage: string;
  description: string;
  destinations: HoneymoonDestination[];
  moreHotelsLink: string;
  experiences: HoneymoonExperience[];
  linkName: string;
};
